import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  auctionCard: {
    // on hover the card should be lifted up and shadow should be added
    cursor: "pointer",
    "&:hover": {
      // show blue shadow on hover
      boxShadow: "0px 4px 20px rgba(0, 0, 255, 0.2)",
      transform: "scale(1.04)",
      transition: "all 0.3s ease-in-out",
    },
  },
}));

export default useStyles;
